import {
  Node_Type,
  PluginContainerData_Alignment,
  PluginContainerData_Width_Type
} from "./../../ricos-schema/next-schema/index.js";
const ORIGINAL_SHAPE_WIDTH = 200;
const DEFAULT_COLOR = "#000000";
const SEARCH_DEBOUNCE_MS = 350;
const DEFAULTS = {
  config: {
    alignment: "center",
    size: "CONTENT",
    textWrap: true
  }
};
const RICOS_DEFAULTS = {
  containerData: {
    alignment: PluginContainerData_Alignment.CENTER,
    width: {
      size: PluginContainerData_Width_Type.ORIGINAL
    },
    textWrap: true
  }
};
const SHAPE_COLORS_MODAL_ID = `${Node_Type.SHAPE}.colors`;
const SHAPE_SIZE_MODAL_ID = `${Node_Type.SHAPE}.size`;
const SHAPE_ALIGNMENT_MODAL_ID = `${Node_Type.SHAPE}.alignment`;
const SHAPE_COLOR_PICKER_MODAL_ID = `${Node_Type.SHAPE}.colorPicker`;
const ALLOWED_SHAPE_ATTRIBUTES = [
  "data-bbox",
  "viewBox",
  "xmlns",
  "d",
  "fill",
  "opacity"
];
const VECTOR_ART_CATEGORY_ID = "b8774c7d-152e-4fca-b0bd-69601605d49c";
const SHAPES_CATEGORY_ID = "95ffa6e1-99d0-48a4-a3b8-a935fe630596";
const SHAPE_SEARCH_ITEMS_BASE_URL = "https://apps.wix.com/_api/ricos-media-proxy/public-media/search-items";
export {
  ALLOWED_SHAPE_ATTRIBUTES,
  DEFAULTS,
  DEFAULT_COLOR,
  ORIGINAL_SHAPE_WIDTH,
  RICOS_DEFAULTS,
  SEARCH_DEBOUNCE_MS,
  SHAPES_CATEGORY_ID,
  SHAPE_ALIGNMENT_MODAL_ID,
  SHAPE_COLORS_MODAL_ID,
  SHAPE_COLOR_PICKER_MODAL_ID,
  SHAPE_SEARCH_ITEMS_BASE_URL,
  SHAPE_SIZE_MODAL_ID,
  VECTOR_ART_CATEGORY_ID
};
//# sourceMappingURL=consts.js.map
